export const Subtitle = {
  OFF: 'off',
  ENGLISH: 'en',
};
export const Panel = {
  NO_PANEL: '',
  CAPTIONS_PANEL: 'captionspanel',
  RESOURCE_PANEL: 'resourcepanel',
};
